import {
  initialState,
  Actions,
  State,
  EDIT_FACTURACION,
  EDIT_FACTURACION_SUCCESS,
  EDIT_FACTURACION_ERROR,
  RESET_EDIT_FACTURACION,
} from "../../types/facturacion/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_FACTURACION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_FACTURACION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_FACTURACION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_FACTURACION:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
